import { createSelector } from '@reduxjs/toolkit';
import { convertListToObjectBy, emptyArr, emptyObj } from '@beef/utils';
import { FttbBlocks, PAGE_TYPE_EVENT_NAMES, PAGE_TYPES } from "../../constants/blocks";
import { getPageTypeByUrl } from "../../utils";
import { getContentData } from "./catalogSelectors";
import { getPageType } from "./legacy/shared";
var getBlocksListUnordered = function getBlocksListUnordered(state) {
  var _getContentData;
  return ((_getContentData = getContentData(state)) === null || _getContentData === void 0 ? void 0 : _getContentData.blocks) || emptyArr;
};
export var getBlocksList = function getBlocksList(state) {
  return getBlocksListUnordered(state).slice().sort(function (a, b) {
    return a.positionOrder - b.positionOrder;
  }) || emptyArr;
};
export var getBlocksDict = createSelector([getBlocksList], convertListToObjectBy('alias'));
export var getBlocksAliasList = function getBlocksAliasList(state) {
  return getBlocksList(state).map(function (item) {
    return item.alias;
  }) || emptyArr;
};

/**
 * Separate blocks
 */
export var getHeadingBlock = function getHeadingBlock(state) {
  return getBlocksDict(state)[FttbBlocks.HEADING] || emptyObj;
};
export var getInfoCardsBlock = function getInfoCardsBlock(state) {
  return getBlocksDict(state)[FttbBlocks.INFO_CARDS] || emptyObj;
};
export var getAdvantagesBlock = function getAdvantagesBlock(state) {
  return getBlocksDict(state)[FttbBlocks.ADVANTAGES_CARDS] || emptyObj;
};
export var getAboutConnectionBlock = function getAboutConnectionBlock(state) {
  return getBlocksDict(state)[FttbBlocks.CONNECTION_CARDS] || emptyObj;
};
export var getCheckAddressBlock = function getCheckAddressBlock(state) {
  return getBlocksDict(state)[FttbBlocks.CHECK_ADDRESS] || emptyObj;
};
export var getTariffsBlock = function getTariffsBlock(state) {
  return getBlocksDict(state)[FttbBlocks.TARIFFS] || emptyObj;
};
export var getAdditionalServicesBlock = function getAdditionalServicesBlock(state) {
  return getBlocksDict(state)[FttbBlocks.ADDITIONAL_SERVICES] || emptyObj;
};
export var getDevicesBlock = function getDevicesBlock(state) {
  return getBlocksDict(state)[FttbBlocks.DEVICES] || emptyObj;
};
// export const getQuizBlock = (state) => getBlocksDict(state)[FttbBlocks.QUIZ];
export var getLeavePhoneBlock = function getLeavePhoneBlock(state) {
  return getBlocksDict(state)[FttbBlocks.LEAVE_PHONE] || emptyObj;
};
export var getFAQBlock = function getFAQBlock(state) {
  return getBlocksDict(state)[FttbBlocks.FAQ] || emptyObj;
};
export var getBannerBlock = function getBannerBlock(state) {
  return getBlocksDict(state)[FttbBlocks.BANNER] || emptyObj;
};

/**
 * Selectors for analytics
 */
export var getAnalyticEventType = function getAnalyticEventType(state) {
  return PAGE_TYPE_EVENT_NAMES[getPageType(state)] || getPageTypeByUrl;
};
export var isPageTypeFmc = function isPageTypeFmc(state) {
  return getPageType(state) === PAGE_TYPES.fmc;
};